import request from '@/utils/request';

const baseUserURL = process.env.VUE_APP_USER; // /user
const baseURLAdmin = process.env.VUE_APP_ADMIN;
// 邀请码查询
export const deliveryRegisterPageQuery = (data) => {
  return request({
    method: 'post',
    url: '/deliveryRegister/pageQuery',
    data,
    baseURL: baseUserURL
  });
};
// 获邀请码查询  查询所有派送网点
export const getDispatchSite = (data) => {
  return request({
    method: 'get',
    url: `/deliveryRegister/getDispatchSite`,
    baseURL: baseUserURL
  });
};
// 获邀请码查询  派送车辆类型
export const getDeliveryVehicle = (data) => {
  return request({
    method: 'get',
    url: `/new-dict/data/options?dictType=delivery_vehicle_type_third_party`,
    baseURL: baseURLAdmin
  });
};
// 获邀请码查询  生成邀请码
export const deliveryRegistergenerateCode = (data) => {
  return request({
    method: 'post',
    url: '/deliveryRegister/generateCode',
    data,
    baseURL: baseUserURL
  });
};
// 获邀请码查询  选择提交信息
export const deliveryRegisterAppMenuInfo = (data) => {
  return request({
    method: 'post',
    url: '/deliveryRegister/appMenuInfo',
    data,
    baseURL: baseUserURL
  });
};
// 获邀请码查询  提交处理结果
export const deliveryRegisterHandle = (data) => {
  return request({
    method: 'post',
    url: '/deliveryRegister/handle',
    data,
    baseURL: baseUserURL
  });
};
// 上岗人数登记   分页
export const apiStaffRegistrationPage = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/staffRegistration/page',
    data
  });
};
// 上岗人数登记   新增
export const apiStaffRegistrationAdd = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/staffRegistration/add',
    data
  });
};
// 上岗人数登记   编辑
export const apiStaffRegistrationEdit = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/staffRegistration/edit',
    data
  });
};
